import {createContext, useContext} from 'react';

import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {BenchlingNodeStatus} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeConstants';

export interface BenchlingNodeSectionInfo {
  name: string;
  icon: BenchlingIconName;
  count: number;
}

export interface BenchlingNodeContextValue {
  status?: BenchlingNodeStatus;
  statusDescription?: string | JSX.Element;
  isDisabled: boolean;
}

const DEFAULT_BENCHLING_NODE_CONTEXT_VALUE: BenchlingNodeContextValue = {
  isDisabled: false,
};

/* @package */
export const BenchlingNodeContext = createContext(DEFAULT_BENCHLING_NODE_CONTEXT_VALUE);

/* @package */
export const useBenchlingNodeContext: () => BenchlingNodeContextValue = () =>
  useContext(BenchlingNodeContext);
